import { useTranslation } from 'react-i18next'

import { EMPTY_LIST } from '../../../../constants/common'
import { useInfiniteItemsListLoader } from '../../../../hooks'
import { EntityProfileTabUpdates } from '../../../Entity'
import { getMockViewingLogEvents } from '../../../RentalPortalViewing'
import { useViewingProfileContext } from '../RentalPortalViewingProfile.hooks'

import { VIEWING_UPDATES_PAGE_SIZE } from './RentalPortalViewingProfileUpdates.constants'
import { toTranslatedViewingUpdates } from './RentalPortalViewingProfileUpdates.utils'

function RentalPortalViewingProfileUpdates() {
  const { t } = useTranslation()

  const { viewingData } = useViewingProfileContext()

  const viewingId = viewingData?.id

  const {
    getThresholdItemProps,
    hasError,
    items,
    loadingInitial,
    loadingMore,
  } = useInfiniteItemsListLoader({
    apiParams: { page_size: VIEWING_UPDATES_PAGE_SIZE, viewing_id: viewingId },
    getData: getMockViewingLogEvents,
    loadPermission: Boolean(viewingId),
    withPagination: true,
  })

  return (
    <EntityProfileTabUpdates
      getThresholdItemProps={getThresholdItemProps}
      hasError={hasError}
      isLoading={loadingInitial}
      isLoadingMore={loadingMore}
      items={toTranslatedViewingUpdates({ items: items ?? EMPTY_LIST, t })}
    />
  )
}

export default RentalPortalViewingProfileUpdates
